import createContext from '@ant-design/create-react-context';
const RowContext = createContext({});
export default RowContext;
